import { Link } from "react-router-dom";
import Logo from "@/components/site/Logo";

export default function Footer() {
  return (
    <footer className="border-t border-border bg-background">
      <div className="px-6 sm:px-10 lg:px-16 xl:px-24 py-16 grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-5">
          <div className="mb-6">
            <Logo size="lg" />
          </div>
          <p className="text-muted-foreground max-w-md leading-relaxed text-sm">
            Akay — entreprise de nettoyage de bureaux et de fin de chantier en Belgique.
            Au service des entreprises, syndics et entrepreneurs.
          </p>
        </div>

        <div className="lg:col-span-2">
          <div className="text-xs uppercase tracking-[0.2em] text-muted-foreground mb-5">Services</div>
          <ul className="space-y-2 text-sm">
            <li><a href="#services" className="hover:text-[hsl(var(--accent))]">Bureaux</a></li>
            <li><a href="#services" className="hover:text-[hsl(var(--accent))]">Chantiers</a></li>
            <li><a href="#devis" className="hover:text-[hsl(var(--accent))]">Devis gratuit</a></li>
          </ul>
        </div>

        <div className="lg:col-span-2">
          <div className="text-xs uppercase tracking-[0.2em] text-muted-foreground mb-5">Société</div>
          <ul className="space-y-2 text-sm">
            <li><a href="#process" className="hover:text-[hsl(var(--accent))]">Méthode</a></li>
            <li><a href="#zones" className="hover:text-[hsl(var(--accent))]">Zones</a></li>
            <li><a href="#faq" className="hover:text-[hsl(var(--accent))]">FAQ</a></li>
            <li><Link to="/admin/login" className="hover:text-[hsl(var(--accent))]" data-testid="footer-admin-link">Espace admin</Link></li>
          </ul>
        </div>

        <div className="lg:col-span-3">
          <div className="text-xs uppercase tracking-[0.2em] text-muted-foreground mb-5">Contact</div>
          <ul className="space-y-2 text-sm">
            <li><a href="tel:0470628055" className="hover:text-[hsl(var(--accent))]">0470 62 80 55</a></li>
            <li><a href="mailto:info@akaynet.com" className="hover:text-[hsl(var(--accent))]">info@akaynet.com</a></li>
            <li className="text-muted-foreground">Lun – Sam · 7h – 20h</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-border px-6 sm:px-10 lg:px-16 xl:px-24 py-6 flex flex-col sm:flex-row justify-between gap-3 text-xs text-muted-foreground">
        <div>© {new Date().getFullYear()} Akay — Tous droits réservés.</div>
        <div>Liège · Limbourg · Belgique</div>
      </div>
    </footer>
  );
}
